
import { Vue } from "vue-class-component";

export default class Maps extends Vue {}
